<template>
  <v-menu
    bottom
    left
    min-width="200"
    max-width="300"
    nudge-left="12"
    offset-x
    style="z-index:9999;"
    transition="slide-y-transition"
    v-model="showMenu"
  >
    <template v-slot:activator="{ on }">
      <!-- <v-btn
        v-on="on"
        color="rgba(0,0,0,0.3)"
        dark
        fab
        fixed
        style="top: 150px;"
        top
      >
        <v-icon>mdi-settings</v-icon>
      </v-btn> -->
      <fab
        ref="fab"
        v-on="on"
        @onFloatBtnClicked="themeBtnListener"
        :menuOpen="showMenu"
      />
    </template>
    <v-card :height="cardHeight" class="scroll">
      <v-container grid-list-xl>
        <v-card flat :style="cssTheme">
          <v-card flat class="d-flex justify-center">
            <span class="text-uppercase">Theme Color</span>
          </v-card>
          <v-row justify="center">
            <v-col cols="auto">
              <v-avatar
                v-for="(color, key) in themeColor"
                :key="key"
                :color="color"
                class="ml-2"
                :size="selectedTheme === key ? 46 : 23"
                @click="setColor(key, color)"
              />
            </v-col>
          </v-row>
          <v-divider class="mt-3" />
          <v-card flat class="d-flex justify-center">
            <span class="text-uppercase mt-3">Theme Image</span>
          </v-card>
          <v-card flat v-for="(img, key) in bgImages" :key="key" class="mt-2">
            <v-img
              :src="img"
              height="120"
              :class="selectedTheme === key ? 'selected_img' : ''"
              @click="setColor(key, themeColor[key])"
            />
          </v-card>
        </v-card>
      </v-container>
    </v-card>
  </v-menu>
</template>
<script>
import { mapState, mapMutations } from "vuex";
//src/components/material/Fab.vue
import fab from "@/components/material/Fab.vue";
export default {
  components: {
    fab
  },
  data() {
    return {
      themeColor: {
        cyan: "#00B8AF",
        red: "#FF546A",
        yellow: "#FFA100",
        purple: "#8241F9",
        blue: "#068EF1"
      },
      cardHeight: 800,
      selecedSize: 46,
      normalSize: 23,
      selectedTheme: this.$config.theme,
      bgImages: {
        cyan: require("@/assets/themes/theme_cyan/img_homecard_bg.svg"),
        red: require("@/assets/themes/theme_red/img_homecard_bg.svg"),
        yellow: require("@/assets/themes/theme_yellow/img_homecard_bg.svg"),
        purple: require("@/assets/themes/theme_purple/img_homecard_bg.svg"),
        blue: require("@/assets/themes/theme_blue/img_homecard_bg.svg")
      },
      showMenu: false
    };
  },
  watch: {
    showMenu(val) {
      if (!val) {
        this.$refs.fab.hiddenFab();
      }
    }
  },
  computed: {
    ...mapState(["theme"]),
    cssTheme() {
      return {
        "--active-theme": this.$vuetify.theme.themes.light.primary
      };
    }
  },
  mounted: function() {
    let resizeId;
    window.addEventListener("resize", () => {
      clearTimeout(resizeId);
      resizeId = setTimeout(this.cardHeightReset, 500);
    });
  },
  beforeDestroy: function() {
    let resizeId;
    window.removeEventListener("resize", () => {
      clearTimeout(resizeId);
      resizeId = setTimeout(this.cardHeightReset, 500);
    });
  },
  created() {
    this.cardHeight = this.getCardHeight();
  },
  methods: {
    ...mapMutations(["updateTheme"]),
    setColor(theme, color) {
      this.selectedTheme = theme;
      this.$vuetify.theme.themes.light.primary = color;
      this.updateTheme(theme);
      // this.$refs.fab.hiddenFab();
    },
    themeBtnListener(val) {
      if (val.goal === "OpenThemeMenu") {
        this.showMenu = !this.showMenu;
      }
    },
    cardHeightReset() {
      this.cardHeight = this.getCardHeight();
      if (this.cardHeight > document.documentElement.clientHeight) {
        this.cardHeight = document.documentElement.clientHeight;
      }
    },
    getCardHeight() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "500";
        case "sm":
          return "500";
        case "md":
          return "800";
        case "lg":
          return "800";
        case "xl":
          return "800";
      }
    }
  }
};
</script>
<style>
.selected_img {
  border-top: 3px solid #263238 !important;
  border-bottom: 3px solid #263238 !important;
  border-left: 3px solid #263238 !important;
  border-right: 3px solid #263238 !important;
}
.scroll {
  overflow-y: auto;
}
</style>
